import { Fragment } from 'react';

import { useJobPostingContext } from '@/contexts/job-posting-context';
import { POOL } from '@/types/channels';

import { ChannelForm } from './channel-form';
import { ChannelSummary } from './channel-summary';
import { PoolForm } from './pool-form';
import { TotalBudgetReceipt } from './total-budget-receipt';

export function CampaignDetails() {
  const { hookForm, selectedChannelSlugs } = useJobPostingContext();
  const { watch } = hookForm;
  const channelsFormData = watch('channels');

  return (
    <div className="flex gap-6 overflow-hidden">
      <div className="flex flex-col gap-3 overflow-auto">
        {Object.keys(channelsFormData).map(channelSlug => (
          <Fragment key={channelSlug}>
            {watch(`channels.${channelSlug}.isExpanded`) ? (
              <ChannelForm channelSlug={channelSlug} />
            ) : (
              <ChannelSummary channelSlug={channelSlug} />
            )}
          </Fragment>
        ))}

        {selectedChannelSlugs.includes(POOL) && <PoolForm />}
      </div>

      <div className="bg-fx-neutral-200 h-full w-px shrink-0" />

      <div className="sticky top-0 shrink-0 self-start">
        <TotalBudgetReceipt />
      </div>
    </div>
  );
}
